import React from "react";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Tabs } from "antd";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import Departure from "../../Pages/Departure";
import UpComming from "../../Pages/UpComming";
import { Container } from "reactstrap";
import { useSystem } from "@/utils/hooks/useLocation";


export const MakkahCampain = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentSystem, location } = useSystem()



  const items = [
    {
      key: "arrival-campaign",
      label: t("MAKKAH_CAMPAIGNS_UPCOMING"),
      children: <UpComming />,
    },
    {
      key: "departure-campaign",
      label: t("MAKKAH_CAMPAIGNS_DEPARTURE"),
      children: <Departure />,
    },
  ];

  const onChange = (key) => {
    navigate(`/app/${currentSystem}/${key}`);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("MAKKAH_CAMPAIGNS_TITLE")} />

      <Container fluid>
        <Tabs
          activeKey={
            location.pathname.endsWith("/departure-campaign")
              ? "departure-campaign"
              : "arrival-campaign"
          }
          items={items}
          onChange={onChange}
        />
      </Container>
    </Stack>
  );
};
